import { useState, useEffect } from 'react';
import flipperClient from '../../services/flipper-api/flipper-api.service';

const QA_CONFIG = {
  experimentId: '65c6a709-4d36-48de-a7f8-33bef9920657',
  variantId: 'c58edd83-7c16-4fc6-a61a-9946a62c84f2',
};

const PROD_CONFIG = {
  experimentId: 'a91963e4-c753-4920-b81a-b1718c91ca78',
  variantId: '14f4bb56-16bb-4208-b12b-a5170deb377a',
};

/**
 * Determines whether the current user is bucketed into the Recommended Themes experiment variant.
 * Bucketing is based on the Segment anonymous ID obtained from `analytics.user().anonymousId()`.
 * Returns `true` if the user is in the variant, `false` if in control or when rollout is 0.
 */
const useRecommendedThemesExperiment = (): boolean => {
  const [isVariant, setIsVariant] = useState(false);
  const [anonymousId, setAnonymousId] = useState('');
  const config = process.env.REACT_APP_APP_ENV === 'production' ? PROD_CONFIG : QA_CONFIG;
  const experimentId = config.experimentId;

  useEffect(() => {
    let cancelled = false;
    window.analytics?.ready?.(() => {
      const id = window.analytics?.user?.()?.anonymousId?.() ?? '';
      if (!cancelled) setAnonymousId(id);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!anonymousId) return;

    let cancelled = false;

    flipperClient
      .getAssignment({
        experimentId: experimentId,
        bucketingId: anonymousId,
      })
      .then((result: any) => {
        if (!cancelled) setIsVariant(result?.data?.variant_id === config.variantId);
      })
      .catch(() => {
        if (!cancelled) setIsVariant(false);
      });

    return () => {
      cancelled = true;
    };
  }, [anonymousId, experimentId, config.variantId]);

  return isVariant;
};

export default useRecommendedThemesExperiment;
